import {Platform} from 'react-native';
import {openURL} from '@eCommerce/frontend-legacy-shared-library-native';
import {Routes} from 'models/Navigation';
import {navigationRef} from 'utils/navigation';

/**
 * Determines if we're running on localhost
 */
export const isLocalhost = (): boolean => {
  if (Platform.OS === 'web') {
    return window.location.hostname === 'localhost';
  }
  return false;
};

/**
 * Gets the appropriate signin URL based on environment
 * For localhost: navigates to local signin route
 * For production: uses /rewards/signin
 */
export const getSigninUrl = (params?: string): string => {
  return `/rewards/signin${params ? `?${params}` : ''}`;
};

/**
 * Navigates to signin - either local route or external URL
 */
export const navigateToSignin = (params?: string): void => {
  const signinUrl = getSigninUrl(params);
  if (isLocalhost()) {
    // On localhost, use React Navigation to go to local signin screen
    navigationRef?.current?.navigate(Routes.Main.Signin);
  } else {
    // Use openURL for external navigation
    openURL(signinUrl);
  }
};
